import { numberToABC, numberToRoman } from '@doltech/utils/lib/text';
import { range } from 'lodash';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { MatchingHeadingAnswerProps } from '../../../../../student-do-test-questions/MatchingHeadingAnswer';
import { useTestSubmissionStore } from '../../../../model/test-submissions.hook';
import { DoTestQuestionMatchingMobile } from '../DoTestQuestionMatchingMobile';

export const DoTestMatchingHeadingMobile = observer((props: MatchingHeadingAnswerProps) => {
  const { data, currentSection } = props;
  const {
    formattedQuestionNo,
    onRemoveAnswerAtIndex,
    onAnswerQuestion,
    userAnswers,
    options,
    paragraphKeys,
  } = data;
  const store = useTestSubmissionStore();

  const dropOption = React.useMemo(() => {
    return range(currentSection.paragraphCount)
      .map((paragraphIndex) => {
        const label = numberToABC(paragraphIndex + 1);

        return {
          key: paragraphIndex,
          value: `Paragraph ${label}`,
        };
      })
      .filter((o) => paragraphKeys.includes(o.key));
  }, [currentSection, paragraphKeys]);

  const dragOption = React.useMemo(() => {
    return options.map((option) => {
      const { key, value } = option;
      const label = numberToRoman(key + 1);
      return {
        key,
        value: `${key}`,
        text: `${value}`,
        circleText: `${label}`,
      };
    });
  }, [options]);

  return (
    <DoTestQuestionMatchingMobile
      title="Headings"
      options={dragOption}
      onRemoveAnswerAtIndex={onRemoveAnswerAtIndex}
      onAnswerQuestion={(input) => {
        if (store.preventUserAction()) return;
        onAnswerQuestion(input);
      }}
      questionList={dropOption}
      userAnswers={userAnswers}
      formattedQuestionNo={formattedQuestionNo}
      numberToString={numberToRoman}
    />
  );
});
